import {AxiosResponse} from "axios";
import Api from "./api";

export default class UserService {
    static async list(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/user/list', fields);
    }

    static async query(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/user/query', fields);
    }

    static async update(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/user/update', fields);
    }

    static async updateInfo(fields: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/user/update_info', fields);
    }
}